module.exports = __webpack_public_path__ + "img/CodelyTV.0bb12a62.jpg";